/* ShellCanvas — iter-237
 *
 * Canonical right-of-sidebar content container for every shell-
 * level page in ChainFlow. Encapsulates the offset class string
 * that iter-236 proved must NEVER drift:
 *
 *     md:ml-[var(--cf-sidebar-w,300px)]
 *     transition-[margin-left] duration-300 ease-out
 *
 * Pre-iter-237 every shell page hand-rolled this class string
 * (~40 consumers). The Deal Room overlap bug (iter-236) happened
 * precisely because one page diverged from the canonical pattern
 * by using `md:flex` + `flex-1` instead. ShellCanvas removes that
 * possibility by making the offset a single source of truth.
 *
 * Design constraints (per user):
 *   • Infrastructure only — produces identical DOM/classes to
 *     the hand-rolled pattern so no visual change ships.
 *   • Lightweight — no new state, no new context, no new prop
 *     gymnastics. Pure render-time class composition.
 *   • Forwards refs so existing scroll-container refs keep
 *     working.
 *   • Accepts `as` for pages that need a `<main>` semantic vs a
 *     plain `<div>` container.
 *   • Passes through `data-testid` + any other DOM attrs.
 */
import React, { forwardRef } from "react";

const CANONICAL_SHELL_OFFSET =
  "md:ml-[var(--cf-sidebar-w,300px)] transition-[margin-left] duration-300 ease-out";

const ShellCanvas = forwardRef(function ShellCanvas(
  { as: Tag = "div", className = "", children, ...rest },
  ref,
) {
  return (
    <Tag
      ref={ref}
      className={[CANONICAL_SHELL_OFFSET, className].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </Tag>
  );
});

export { CANONICAL_SHELL_OFFSET };
export default ShellCanvas;
